import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subject, takeUntil } from 'rxjs';
import { EWB_CREATE_COMPONENTS } from 'src/app/core/enums/ewbConfiguration.enum';
import { SelectedKpi } from 'src/app/core/models/insight-configuration.model';
import { RemoveSelectedImpactedKPI, UpdateStepValidity } from 'src/app/core/store/ewb-configuration/ewb-configuration.action';
import { EwbImpactedKpiSelectionPopupComponent } from './ewb-impacted-kpi-selection-popup/ewb-impacted-kpi-selection-popup.component';

@Component({
  selector: 'app-ewb-impacted-kpi',
  templateUrl: './ewb-impacted-kpi.component.html',
  styleUrls: ['./ewb-impacted-kpi.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EwbImpactedKpiComponent {
public selectKpiModalRef: BsModalRef
  public unsubscribe  = new Subject<void>();
  public dataSource = new MatTableDataSource();
  public selectedKpis : SelectedKpi[];
  public count = 0;
  public disable : boolean;
  public displayedColumns: string[] = ['name', 'role', 'department', 'ahLevel', 'frequency', 'buttons'];

  constructor(
    public router: Router,
    public modalService: BsModalService,
    private store: Store,
    private changeDetectorRef: ChangeDetectorRef
  ) {}

  @ViewChild('scheduledOrdersPaginator', {static: true}) paginator :MatPaginator;

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.store.dispatch(new UpdateStepValidity(EWB_CREATE_COMPONENTS.IMPACTED_KPIS, true));
    this.getSelectedKPIs();
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  public navigateToLanding(): void {
    this.router.navigateByUrl('/home')
  }

  public getSelectedKPIs() {
    this.store.select(state => state.configurations.ewb.impactedKpiSelected).pipe(takeUntil(this.unsubscribe))
    .subscribe(selectedKPIs => {
      this.selectedKpis = selectedKPIs;
      this.dataSource.data = selectedKPIs;
      this.count = this.selectedKpis.length
      this.changeDetectorRef.detectChanges();
    })
  }

  public onSelectKpiClicked() {
    this.selectKpiModalRef = this.modalService.show(EwbImpactedKpiSelectionPopupComponent, {
      class: 'modal-lg kpi-selection',
      ignoreBackdropClick: true
    })
  }

  public deleteSelectedKpi(kpi: any) {
    this.store.dispatch(new RemoveSelectedImpactedKPI(kpi));
  }

}
